import { createRenderer as createRendererDX } from "./universal.js";
import { mergeProps } from "solid-js/dist/solid.js";
export function createRenderer(options) {
  const renderer = createRendererDX(options);
  renderer.mergeProps = mergeProps;
  return renderer;
}